import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class FuseConfirmDialogComponent {

    public confirmHead: string;
    public confirmMessage: string;
    public confirmOkText: string;
    public confirmCancelText: string;

    constructor(public dialogRef: MatDialogRef<FuseConfirmDialogComponent>) {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/core/components/confirm-dialog/confirm-dialog.component.ts